import ConfirmBox from "../../../../components/boxes/ConfirmBox";
import XsCont from "../../../../components/containers/Xs";
import { API_URL } from "../../../../consts/ApiUrl";
import { validationMessage } from "../../../../consts/ValidationMessage";
import { Typography, Box, TextField, Button } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmPhoneNumStep: React.FC = () => {
  const navigate = useNavigate();
  const [confirmationCode, setConfirmationCode] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmationCode(e.target.value);
    setError("");
  };
  const handleButtonClick: () => Promise<void> = async (): Promise<void> => {
    if (!confirmationCode.trim()) {
      setError(`認証コード${validationMessage.REQUIRED}`);
      return;
    }
    try {
      const numberChangeInfo = JSON.parse(
        sessionStorage.getItem("numberChangeInfo") || "{}"
      );
      const idToken: string = sessionStorage.getItem("idToken") || "";
      const verifyResponse: Response = await fetch(API_URL.VERIFY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authentication: sessionStorage.getItem("idToken") || "",
        },
        body: JSON.stringify({
          mode: "check",
          code: confirmationCode,
          request_id: numberChangeInfo.requestId,
        }),
      });
      if (!verifyResponse.ok) {
        setError("認証コードが正しくありません。");
        return;
      }
      const response: Response = await fetch(API_URL.USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authentication: idToken,
        },
        body: JSON.stringify({
          operation: "update",
          chargePhoneNumber: numberChangeInfo.chargePhoneNumber,
        }),
      });
      if (!response.ok) {
        if (response.status === 401) {
          navigate("/signin");
        } else {
          navigate("/error");
        }
        return;
      }
      sessionStorage.removeItem("numberChangeInfo");
      navigate("/update/comp");
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <XsCont>
      <ConfirmBox>
        <Box mt={2} mb={3} textAlign="center">
          <Typography variant="h5" gutterBottom>
            認証コード入力
          </Typography>
        </Box>
        <Box mt={2} mb={2} textAlign="center">
          <Typography variant="body2">
            入力された電話番号ににSMSを送信しました。
            <br />
            SMSをご確認の上認証コードを入力してください。
          </Typography>
        </Box>
        <TextField
          label="認証コード"
          variant="outlined"
          required
          fullWidth
          sx={{ maxWidth: "320px", marginTop: "5px" }}
          value={confirmationCode}
          onChange={handleChange}
          error={!!error}
          helperText={error}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleButtonClick}
          sx={{ maxWidth: "320px", marginTop: "15px" }}
        >
          認証
        </Button>
      </ConfirmBox>
    </XsCont>
  );
};

export default ConfirmPhoneNumStep;
